// eslint-disable-next-line
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, HashRouter, Route, Switch } from "react-router-dom";
import blogdata from './data/blogdata.json';
import Singleblogdata from './data/single-blogdata.json';
import HomeV1 from './components/home-v1';
import HomeV2 from './components/home-v2';
import HomeV3 from './components/home-v3';
import HomeV4 from './components/home-v4';
import Property from './components/property';
import AvilableProperty from './components/availavbe-property';
import PropertiesByCity from './components/properties-by-city';
import RecentProperties from './components/recent-properties';
import PropertyDetails from './components/property-details';
import About from './components/about';
import Advisor from './components/advisor';
import Pricing from './components/pricing';
import UserList from './components/user-list';
import Registraion from './components/registration';

import Faq from './components/faq';
import News from './components/news';
import NewsDetails from './components/news-details';
import Contact from './components/contact';
import SearchMap from './components/search-map';
import SearchGrid from './components/search-grid';
import SearchList from './components/search-list';
import AddNew from './components/add-property';
import Services from './components/services';
import Areas from './components/new-components/allareas';
import Blog from './components/blog-components/blog';


import Error from './components/error';
import FloatingWhatsApp from './utils/FloatingButton';
import CallingButton from './utils/CallingButton';
import FloatingContactButtons from './utils/floatingContactButtons';
import BlogDetails from './components/blog-components/blog-details';
import BlogMain from './components/blog-components/blog-main';
import TeamDetails from './components/team-list';
import Privacy from './components/new-components/privacy';
import TermsCondition from './components/new-components/termsCondition';
import ScrollToTop from './utils/scrollToTop';
import sellMain from './components/sell/sellMain';
import Developer from './components/Developers/developer';
import DeveloperMain from './components/Developers/developerMain';



//import GetInTouch from './utils/getInTouch';


class Root extends Component {
    render() {
        return (

            <Router>
                <ScrollToTop />
                {/* <HashRouter basename="/"> */}
                <div>
                    <Switch>
                        <Route exact path="/" component={HomeV1} />
                        {/* <Route path="/home-v2" component={HomeV2} />
                    <Route path="/home-v3" component={HomeV3} />
                    <Route path="/home-v4" component={HomeV4} />
                    <Route path="/property" component={Property} /> */}
                        {/* <Route path="/availavbe-property" component={AvilableProperty} /> */}
                        {/* <Route path="/properties-by-city" component={PropertiesByCity} /> */}
                        <Route path="/recent-properties" component={RecentProperties} />
                        <Route path="/property-details/:propertySlug" component={PropertyDetails} />
                        <Route path="/about" component={About} />
                        {/* <Route path="/advisor" component={Advisor} /> */}
                        {/* <Route path="/pricing" component={Pricing} /> */}
                        {/* <Route path="/user-list" component={UserList} /> */}
                        {/* <Route path="/registration" component={Registraion} /> */}

                        <Route path="/faq" component={Faq} />
                        {/* <Route path="/news" component={News} /> */}
                        {/* <Route path="/news-details" component={NewsDetails} /> */}
                        <Route path="/contact" component={Contact} />



                        {/* all routes combination routes  */}
                        <Route path="/properties/:type(buy|sell|rent)/:buildingType(apartment|townhouse|villas|penthouse|studio-apartment)/:constructionSlugs(ready|offplan)/:locality/:bedrooms(1bedrooms|2bedrooms|3bedrooms|4bedrooms)" component={SearchGrid} />
                        {/* <Route path="/properties/:type(buy|sell|rent)/:buildingType(apartment|townhouse|villas|penthouse|studio-apartment)/:constructionSlugs(ready|offplan)/:locality" component={SearchGrid} /> */}
                        <Route path="/properties/:type(buy|sell|rent)/:buildingType(apartment|townhouse|villas|penthouse|studio-apartment)/:constructionSlugs(ready|offplan)/:locality?" component={SearchGrid} />
                        <Route path="/properties/:type(buy|sell|rent)/:buildingType(apartment|townhouse|villas|penthouse|studio-apartment)/:constructionSlugs(ready|offplan)" component={SearchGrid} />
                        <Route path="/properties/:type(buy|sell|rent)/:buildingType(apartment|townhouse|villas|penthouse|studio-apartment)" component={SearchGrid} />
                        <Route path="/properties/:type(buy|sell|rent)" component={SearchGrid} />

                        {/* only for buildingType routes */}
                        <Route path="/properties/:buildingType(apartment|townhouse|villas|penthouse|studio-apartment)" component={SearchGrid} />

                        {/* only for ConstructionSlug routes */}
                        <Route path="/properties/:constructionSlugs(ready|offplan)" component={SearchGrid} />

                        {/* only for Locality routes */}
                        <Route path="/properties/:locality" component={SearchGrid} />

                        {/* only for BHKType routes */}
                        <Route path="/properties/:bedrooms(1bedrooms|2bedrooms|3bedrooms|4bedrooms)" component={SearchGrid} />

                        <Route path="/properties/:type(buy|sell|rent)" component={SearchGrid} />

                        {/* <Route path="/properties/:type-:buildingType"  component={SearchGrid} /> */}

                        {/* <Route path=""  component={SearchGrid} /> */}
                        <Route path="/properties" component={SearchGrid} />



                        <Route path="/add-property" component={AddNew} />

                        <Route path="/services" component={Services} />
                        {/* <Route path="/areas" component={Areas} /> */}
                        <Route path="/blog" component={Blog} />
                        {/* <Route path="/blogdetails" component={BlogDetails} /> */}
                        <Route path="/blogdetails/:slug" component={BlogMain} />
                        {/* cards */}
                        <Route path="/developers" component={Developer} />
                        {/* details */}
                        <Route path="/developername/dubai/:developerSlug" component={DeveloperMain} />


                        <Route path="/team" component={TeamDetails} />
                        <Route path="/privacy" component={Privacy} />
                        <Route path="/terms" component={TermsCondition} />

                        <Route path="/sell" component={sellMain} />




                        <Route component={Error} />

                    </Switch>
                    <FloatingContactButtons />

                    {/*<GetInTouch/>*/}
                </div>
                {/* </HashRouter> */}
            </Router>
        )
    }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('realdeal'));
